
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.17.75A1.52 1.52 0 004 1.29L.364 5.722l-.003.003A1.582 1.582 0 000 6.804c0 .128.023.252.065.367a1.599 1.599 0 00.303.567l8.466 9.97c.295.358.733.542 1.166.542.433 0 .87-.184 1.165-.543l8.467-9.966a1.598 1.598 0 00.308-.582 1.075 1.075 0 00.06-.39 1.583 1.583 0 00-.36-1.042l-3.635-4.43-.004-.006A1.52 1.52 0 0014.83.75H5.17zm11.6 4.96l-2.274-2.772h-8.99L3.23 5.71h13.54zM3.4 7.897l6.6 7.772 6.602-7.772H3.4z"}})])
          )
        }
      }
    